
export interface QuickActionItem {
    id: string;
    actionName: string;
    internalLinkRoute: string;
    externalLink: string;
    rolesMatch: string; // only for non-defaults
    groupName: string; // only for defaults
}

export interface QuickActionGroup {
    groupName: string;
    quickActionItems: QuickActionItem[];
}


export interface DefaultQuickActionGroup {
    rolesMatch: string;
    defaultActions: QuickActionItem[];
}

export const QuickActionsStorageKey = 'SavedQuickActions';